// validators.js — Pure validation helpers, each returns { valid, field, message }

export const validateBasicFields = (packData) => {
    if (!packData.group || packData.group === '-1' || packData.group === '')
        return { valid: false, field: 'group', message: 'Please select group type' };

    if (packData.datesType === '-1' || packData.datesType === '')
        return { valid: false, field: 'datesType', message: 'Please select date type' };

    if (packData.title.length < 3 || packData.title.length > 50)
        return { valid: false, field: 'title', message: 'Title error' };

    if (packData.overview.length < 50 || packData.overview.length > 4000)
        return { valid: false, field: 'overview', message: 'Overview error' };

    if (packData.days < 1 || packData.days > 99)
        return { valid: false, field: 'days', message: 'Days should be greater than 0' };

    if (packData.nights < 0 || packData.nights > 99)
        return { valid: false, field: 'nights', message: 'Nights must be between 0 and 99' };

    return { valid: true };
};

export const validateBasicFieldsOthers = (packData) => {
    if (packData.title.length < 3 || packData.title.length > 50)
        return { valid: false, field: 'title', message: 'Title error' };

    if (packData.overview.length < 50 || packData.overview.length > 4000)
        return { valid: false, field: 'overview', message: 'Overview error' };

    if (!packData.openTime || packData.openTime === '')
        return { valid: false, field: 'openTime', message: 'Opening Time is required' };

    if (!packData.closeTime || packData.closeTime === '')
        return { valid: false, field: 'closeTime', message: 'Closing Time is required' };

    return { valid: true };
};

export const validateQuickView = (quickView) => {
    if (!Array.isArray(quickView.type) || quickView.type.length === 0)
        return { valid: false, field: 'type', message: 'Type must be a non-empty array.' };

    if (quickView.type.some((item) => typeof item !== 'string' || item.trim() === ''))
        return { valid: false, field: 'type', message: 'Type contains empty or invalid items.' };

    const fieldsToValidate = ['difficulty', 'duration', 'baseCities', 'maxSlots', 'area'];

    for (const field of fieldsToValidate) {
        const value = quickView[field];
        if (
            value === null ||
            value === undefined ||
            value === '-1' ||
            (typeof value === 'string' && value.trim() === '')
        ) {
            const label = field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1');
            return { valid: false, field, message: `Quickview ${label} is required.` };
        }
    }

    return { valid: true };
};

export const validateItinerary = (packData) => {
    // if (packData.itiType === '-1' || packData.itiType === '')
    //     return { valid: false, field: 'itiType', message: 'Please select itinerary type' };

    const { itinerary } = packData;

    if (!Array.isArray(itinerary) || itinerary.length === 0)
        return { valid: false, field: 'itinerary', message: 'At least one activity should be entered.' };

    for (let i = 0; i < itinerary.length; i++) {
        const day = itinerary[i];

        if (typeof day.dayHeading !== 'string' || day.dayHeading.trim() === '')
            return { valid: false, field: day, message: `Activity ${i + 1} heading is required.` };

        if (typeof day.dayDescription !== 'string' || day.dayDescription.trim() === '')
            return { valid: false, field: day, message: `Activity ${i + 1} description is required.` };
    }

    return { valid: true };
};

export const validateTimeSlots = (packData) => {
    // const hasEmptySlot = packData.timeSlots.some((slot) => !slot || slot.trim() === '');
    // if (hasEmptySlot) return { valid: false, field: 'timeSlots', message: 'Please select all time slots' };
    return { valid: true };
};
export const validateImages = (imgData) => {
    const wallCount = (imgData?.oldWallImg?.length || 0) + (imgData?.newWallImg?.length || 0);
    if (wallCount < 5) return { valid: false, message: 'Upload at least 5 Wallpaper Images' };

    const thumbCount = (imgData?.oldThumbImg?.length || 0) + (imgData?.newThumbImg?.length || 0);
    if (thumbCount < 2) return { valid: false, message: 'Upload at least 2 Thumbnail Images' };

    return { valid: true };
};

export const validateTextBlocks = (tempData) => {
    const checks = [
        { key: 'included', ref: 'inExRef', field: 'included', message: 'Add atleast 2 includes' },
        { key: 'excluded', ref: 'inExRef', field: 'excluded', message: 'Add atleast 2 excludes' },
        { key: 'safety', ref: 'safetyRef', field: 'safety', message: 'Add atleast 2 safety points' },
        { key: 'carry', ref: 'thingsRef', field: 'carry', message: 'Add atleast 2 things to carry points' },
        { key: 'terms', ref: 'termsRef', field: 'terms', message: 'Add atleast 1 point to terms', min: 20, max: 1500 }
    ];

    for (const { key, field, message, min = 20, max = 800 } of checks) {
        if (tempData[key].length < min || tempData[key].length > max) return { valid: false, field, message };
    }

    return { valid: true };
};

export const validateFAQs = (FAQs) => {
    for (let i = 0; i < FAQs.length; i++) {
        const faq = FAQs[i];

        if (typeof faq.question !== 'string' || faq.question.trim() === '')
            return { valid: false, field: `question${i}`, message: `Faq ${i + 1} question is required.` };

        if (typeof faq.answer !== 'string' || faq.answer.trim() === '')
            return { valid: false, field: `answer${i}`, message: `Faq ${i + 1} answer is required.` };
    }

    return { valid: true };
};

export const validatePrices = (packData) => {
    for (let index = 0; index < packData.price.length; index++) {
        const item = packData.price[index];
        const isCustom = packData.datesType === 'custom';
        const isFixed = packData.datesType === 'fixed';
        const isBackpackingFixed = packData.group === 'backpacking' && isFixed;

        if (isCustom) {
            if (!item.customPrice) return { valid: false, message: `City ${index + 1} Custom price is missing` };

            if (item.customPrice.room <= 0)
                return { valid: false, message: `City ${index + 1}: Room price must be greater than 0` };

            if (item.customPrice.bed <= 0)
                return { valid: false, message: `City ${index + 1}: Bed price must be greater than 0` };

            if (item.customPrice.perPerson <= 0)
                return { valid: false, message: `City ${index + 1}: Per person price must be greater than 0` };

            if (item.customPrice.groupPrice <= 0)
                return { valid: false, message: `City ${index + 1}: Group price must be greater than 0` };
        }

        if (isFixed && (!item.price || item.price.actual <= 0))
            return { valid: false, message: `City ${index + 1}: Actual price must be greater than 0` };

        if (!item.startCity || item.startCity.length < 2 || item.startCity.length > 30)
            return { valid: false, message: `City ${index + 1} Start city must be between 2 and 30 characters` };

        if (isBackpackingFixed) {
            if (!item.pickupLocation || item.pickupLocation.length < 1)
                return { valid: false, message: `City ${index + 1} Pickup location is required` };
        } else {
            if (!item.meetupPoint || item.meetupPoint.length < 1)
                return { valid: false, message: `City ${index + 1} Meetup point is required` };
        }
    }

    return { valid: true };
};

export const validatePricesOthers = (packData) => {
    for (let index = 0; index < packData.price.length; index++) {
        const item = packData.price[index];

        if (item.actual === null || isNaN(item.actual))
            return { valid: false, message: `Activity ${index + 1} actual price is required.` };
        if (item.reserve === null || isNaN(item.reserve))
            return { valid: false, message: `Activity ${index + 1} reserve amount is required.` };
        if (!item.name || item.name.trim() === '')
            return { valid: false, message: `Activity ${index + 1} name is required.` };
        if (!item?.terms) return { valid: false, message: `Activity ${index + 1} terms are required.` };
    }

    return { valid: true };
};

export const validateInstallments = (prices) => {
    const allValid = prices.every((item) =>
        (item?.instalments || []).every((inst) => inst.comment?.trim().length > 0 && parseFloat(inst.percentage) > 0)
    );

    return allValid
        ? { valid: true }
        : { valid: false, message: 'All installments must have a percentage and comment.' };
};

export const validateTags = (tags) => {
    if (tags.length < 5) return { valid: false, field: 'tags', message: 'You should add minimum of 5 tags' };

    if (tags.some((tag) => tag.length > 50))
        return { valid: false, message: 'One of the tags length is greater than 50' };

    return { valid: true };
};
